/**
 * 预渲染事件触发 Hook
 * 用于在页面渲染完成后触发预渲染插件的事件
 */
import { useEffect } from 'react';

export const usePrerender = () => {
  useEffect(() => {
    // 检查是否在预渲染环境中
    if (typeof window !== 'undefined' && (window as any).__PRERENDER_INJECTED) {
      // 等待页面内容完全渲染(包括图片、动画等)
      setTimeout(() => {
        // 触发预渲染完成事件
        document.dispatchEvent(new Event('render-complete'));
        console.log('✅ Prerender complete event triggered');
      }, 2000); // 等待2秒,确保所有内容渲染完成
    }
  }, []);
};